import Flex from "components/grid/Flex";
import { useTranslation } from "react-i18next";
import HistoryContainerAndTitle from "./HistoryContainerAndTitle";
import { isAnyPresent, makeHistory } from "../../HistoryUtils";
import DateAndValueArray from "./DateAndValueArray";
import YesNoOrChildren from "./YesNoOrChildren";

const ArthroseHistory = ({ anamnesisHistory }) => {
    const { t } = useTranslation();
    const history = makeHistory(anamnesisHistory);
    const isVisible = isAnyPresent(anamnesisHistory, ["haveArthroseData", 'haveArthrose']);
    return (
        <HistoryContainerAndTitle title={t(`anamnesis.arthrose.title`)} isVisible={isVisible}>
            <Flex item grow={0} container column style={{ margin: "5px 0px" }}>
                <YesNoOrChildren
                    {...{
                        label: `Z.n. ${t(`anamnesis.arthrose.title`)}`,
                        switchValue: history.getLatestValueOf("haveArthrose"),
                        arrayValue: history.getLatestSubDataRows("haveArthroseData")
                    }}
                >
                    <DateAndValueArray
                        {...{
                            array: history.getLatestSubDataRows("haveArthroseData"),
                            label: t(`anamnesis.arthrose.title`),
                            booleanValue: history.getLatestSubDataRows("haveArthrose")
                        }}
                    />
                </YesNoOrChildren>

            </Flex>
        </HistoryContainerAndTitle>
    );
};

export default ArthroseHistory;
